<template>
  <div>
    <div id="map" class="map"></div>
    <img v-show="markerShow" ref="markerDom" width="18" src="../../../public/app-assets/image/satellite_trace_mini_program/location.png">
  </div>
</template>

<script>


import {getMapboxToken} from "@/utils/utils";
import mapboxgl from "mapbox-gl";

export default {
  name: 'TraceSourceLandMap',
  data() {
    return {
      baseStyleInfo: '',
      marker: '',
      markerShow: false,
    }
  },
  methods: {
    async getBaseStyleInfo() {
      let response = await this.$http.get('/earthApi/main-info/getBaseStyleInfo');
      if(response.data.status === 200){
        this.baseStyleInfo = response.data.data;
      }
    },
    async initMap() {
      await getMapboxToken()
      await this.getBaseStyleInfo()
      mapboxgl.accessToken = this.globalJS.mapboxToken
      this.map = new mapboxgl.Map({
        container: 'map',
        center:[100, 31],
        zoom: 5,
        preserveDrawingBuffer:true,
        style: this.baseStyleInfo.styleUrl,
        maxZoom: 17,
        minZoom: 0.8,
        attributionControl: false,
        trackResize: false,
        projection: {name:'globe'},
        // 禁用所有交互
        interactive: false,
        dragPan: false,
        dragRotate: false,
        scrollZoom: false,
        touchZoomRotate: false,
        touchPitch: false,
        doubleClickZoom: false,
        boxZoom: false,
        keyboard: false,
        transformRequest: (url) => {
          if (url.indexOf('https://api.mapbox.com') > -1 && this.baseStyleInfo.useRedirect === '1') { //resourceType != 'Tile' &&
            return {
              url: url.replace('https://api.mapbox.com','https://earth.jl1.cn/mapbox'),
            };
          }
        }
      });
      this.map.on('load', () => {
        this.map.setFog({
          "horizon-blend": 0.1,
          "space-color": 'rgba(0, 0, 0, 1)',
          "star-intensity": 0.15
        })
        this.map.addSource('mapbox-dem', {
          type: 'raster-dem',
          url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
          tileSize: 512,
          maxZoom: 14,
        });
        this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1 });
        this.map.addSource('china1m2021', {
          type: 'raster',
          tiles: [
            "https://t0.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=05861044e5fe4135647facbd39abc543"
          ],
          tileSize: 256,
          // scheme: 'tms',
        });
        this.map.addLayer({
          id: 'china1mLayer',
          type: 'raster',
          source: 'china1m2021',
        })
        if (window['flutter_traceSourceLandMapReady']) {
          window['flutter_traceSourceLandMapReady'].postMessage('')
        }
        // this.addMarker(123,42)
      })
    },
    addMarker(lng, lat) {
      this.markerShow = true
      this.map.flyTo({
        center:[lng,lat],
        zoom: 13,
        duration: 0,
      })
      this.marker = new mapboxgl.Marker(this.$refs.markerDom)
          .setLngLat([lng, lat])
          .addTo(this.map)
    }
  },
  mounted() {
    window.traceSourceLandMap = this
    this.initMap()
  },
  beforeDestroy() {
    this.marker.remove()
  }
}
</script>

<style scoped>
.map {
  width: 100%;
  height: 110px;
}
</style>